import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';

function atLeastOneCheckedValidator(minRequired = 1): ValidatorFn {
  return (formGroup: UntypedFormGroup): ValidationErrors | null => {
    const controls = formGroup.controls;
    const checkedCount = Object.keys(controls).filter(key => controls[key].value.checked).length;

    return checkedCount >= minRequired ? null : { atLeastOneCheckedError: true };
  };
}

// function atLeastOneCheckedValidator(minRequired = 1): ValidationErrors | null {
//   return (control: AbstractControl): ValidationErrors | null => {
//     const checked = (control as FormArray).controls.filter(ctrl => ctrl.value);
//     if (checked.length < minRequired) {
//       return {
//         atLeastOneCheckedError: true
//       };
//     }
//     return null;
//   };
// }
@Component({
    selector: 'app-onboarding',
    templateUrl: './onboarding.component.html',
    styleUrls: ['./onboarding.component.scss'],
    standalone: false
})
export class OnboardingComponent implements OnInit {

  constructor(
    private formBuilder: UntypedFormBuilder,
    private api: ApiService,
    private router: Router
  ) { }
  errorMessage = null;
  // brokerOptions = [
  //   {name: 'Plum Underwriting'},
  //   {name: 'Renovation Plan'},
  //   {name: 'Hiscox'},
  //   {name: 'Azur'},
  //   {name: 'Chubb'},
  //   {name: 'Other Broker'},
  // ];
  //   selectedBroker = '';
  referalOptions = [
    { name: 'Employer/CoWorker' },
    { name: 'Sector referral' },
    { name: 'RUL approach' },
    { name: 'Search engine' },
    { name: 'Social media' },
    { name: 'Other' },
  ];
  selectedReferal = '';
  commercialOptions = [
    { name: 'Yes' },
    { name: 'No' }
  ];

  options = [
    { label: 'Broker Network', value: 'broker_network' },
    { label: 'Compass', value: 'compass' },
    { label: 'Cobra', value: 'cobra' },
    { label: 'Willis', value: 'willis' },
    { label: 'Hedron', value: 'hedron' },
    { label: 'Brokerbility', value: 'brokerbility' },
    { label: 'UNA', value: 'UNA' },
    { label: 'Bravo', value: 'bravo' },
    { label: 'Ten', value: 'ten' },
    { label: 'Momentum', value: 'momentum' },
    { label: 'Not a network member', value: 'not_a_network_member' },
  ];
  networkOptions = new UntypedFormArray(
    this.options.map(option => {
      return new UntypedFormGroup({
        label: new UntypedFormControl(option.label),
        value: new UntypedFormControl(option.value),
        checked: new UntypedFormControl(false)
      });
    }), atLeastOneCheckedValidator()
  );
  commercialSelected = '';
  networthOptions = [
    { name: 'Below 500' },
    { name: '501-1000' },
    { name: '1001-2000' },
    { name: 'Above 2000' }
  ];
  networthSelected = '';
  propertyPolicyOptions = [
    { name: 'Below 500' },
    { name: '501-1000' },
    { name: '1001-2000' },
    { name: 'Above 2000' }
  ];
  propertyPolicySelected = '';
  worksInsuranceOptions = [
    { name: 'Yes' },
    { name: 'No' }
  ];
  worksInsuranceSelected = '';
  subBroke = '';
  adminFee = '';
  addOnsV = ''
  isLoading = false;
  firstFormGroup = new UntypedFormGroup({
    fullName: new UntypedFormControl('', Validators.required),
    position: new UntypedFormControl('', Validators.required),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    telephoneDDI: new UntypedFormControl('', [Validators.required, Validators.pattern('(((\\+44)? ?(\\(0\\))? ?)|(0))( ?[0-9]{3,4}){3}')]),
    referralStream: new UntypedFormControl('', Validators.required),
    otherReferal: new UntypedFormControl(''),
    nameOfFirm: new UntypedFormControl('', Validators.required),
    website: new UntypedFormControl('', [Validators.required, Validators.pattern('')]),
    telephoneHead: new UntypedFormControl('', [Validators.required, Validators.pattern('(((\\+44)? ?(\\(0\\))? ?)|(0))( ?[0-9]{3,4}){3}')]),
    fcaRefNum: new UntypedFormControl('', Validators.required),
    addressOne: new UntypedFormControl('', Validators.required),
    addressTwo: new UntypedFormControl(''),
    town: new UntypedFormControl('', Validators.required),
    postCode: new UntypedFormControl('', Validators.required),
    networkoptions: this.networkOptions

  });
  secondFormGroup = new UntypedFormGroup({
    accountsFullName: new UntypedFormControl('', Validators.required),
    accountsPosition: new UntypedFormControl('', Validators.required),
    accountsEmail: new UntypedFormControl('', [Validators.required, Validators.email]),
    telephoneDDIAccounts: new UntypedFormControl('', [Validators.required, Validators.pattern('(((\\+44)? ?(\\(0\\))? ?)|(0))( ?[0-9]{3,4}){3}')]),
    agencyFullName: new UntypedFormControl('', Validators.required),
    agencyPosition: new UntypedFormControl('', Validators.required),
    agencyEmail: new UntypedFormControl('', [Validators.required, Validators.email]),
    telephoneDDIAgency: new UntypedFormControl('', [Validators.required, Validators.pattern('(((\\+44)? ?(\\(0\\))? ?)|(0))( ?[0-9]{3,4}){3}')]),
    claimsFullName: new UntypedFormControl(''),
    claimsPosition: new UntypedFormControl(''),
    claimsEmail: new UntypedFormControl('', [Validators.email]),
    telephoneDDIclaims: new UntypedFormControl('', [Validators.pattern('(((\\+44)? ?(\\(0\\))? ?)|(0))( ?[0-9]{3,4}){3}')]),
    marketFullName: new UntypedFormControl(''),
    marketPosition: new UntypedFormControl(''),
    marketEmail: new UntypedFormControl('', [Validators.email]),
    telephoneDDImarket: new UntypedFormControl('', [Validators.pattern('(((\\+44)? ?(\\(0\\))? ?)|(0))( ?[0-9]{3,4}){3}')]),
  });
  thirdFormGroup = new UntypedFormGroup({
    commercialConstructionSpecialism: new UntypedFormControl('', Validators.required),
    highNetWorthPolicies: new UntypedFormControl('', Validators.required),
    propertyOwnerPolicies: new UntypedFormControl('', Validators.required),
    approachedDeal: new UntypedFormControl(null, Validators.required),
    approachedDealYes: new UntypedFormControl(''),
    subBroke: new UntypedFormControl('', Validators.required),
    adminFeeForm: new UntypedFormControl('', Validators.required),
    adminFeeYes: new UntypedFormControl(''),
    addOns: new UntypedFormControl('', Validators.required),
    addOnsyes: new UntypedFormControl(''),
    // whichMarkets: new FormControl('', Validators.required),
    // otherBroker: new FormControl('', Validators.required),
    worksExpert: new UntypedFormControl('', Validators.required),
    checkboxAgreeCPD: new UntypedFormControl('', Validators.requiredTrue),
    brokerageTrainingContact: new UntypedFormControl('', Validators.required),
    checkboxAgreeTerms: new UntypedFormControl('', Validators.requiredTrue),
    //signatureName: new FormControl('', Validators.required),
    checkboxAgreeSignature: new UntypedFormControl('', Validators.requiredTrue),
  });

  @ViewChild('sigCanvas', { static: false }) myCanvas: ElementRef<HTMLCanvasElement>;
  public context: CanvasRenderingContext2D;

  // submit() {
  //   this.api.submitForm(this.firstFormGroup.value).subscribe((res) => {
  //     console.log(res);
  //   }, err => {
  //     console.log(err.message.toLocaleString());
  //   });
  // }
  // submitStep2() {
  //   console.log(this.secondFormGroup.value);
  // }
  brokerType: string;

  ngOnInit() {
    this.networkOptions.markAsUntouched();
    this.networkOptions.markAsPristine();
  }
  firstNext() {
    console.log("hello")
  }
  submitStep3() {
    // const signature = document.getElementById('sigCanvas') as HTMLCanvasElement;
    // const signatureBase64 = signature.toDataURL();
    // const tobaData = {
    //   ...this.firstFormGroup.value, ...this.secondFormGroup.value, ...this.thirdFormGroup.value,
    //   signatureBase64
    // };
    this.isLoading = true;
    const tobaData = {
      ...this.firstFormGroup.value, ...this.secondFormGroup.value, ...this.thirdFormGroup.value
    };
    this.api.submitOnboardingForm(tobaData).subscribe((res) => {
      this.isLoading = false;
      this.router.navigate(['/thank-you-onboarding']);
    }, err => {
      // Check if the error has a response and a message
      this.isLoading = false;

      if (err.error && err.error.message) {
        this.errorMessage = err.error.message;
      } else {
        this.errorMessage = 'An unexpected error occurred';
      }
    });
  }

  sign(e): void {
    this.context = this.myCanvas.nativeElement.getContext('2d');
    this.context.clearRect(0, 0, 400, 60);
    this.context.font = '40px Satisfy';
    this.context.fillText(e.target.value, 40, 40);
  }

  nameUpdate(e): void {
    this.thirdFormGroup.controls.signatureName.setValue(e.target.value);
    this.sign(e);
  }

}
